export const getElementData = (e) => {
  const { width, height, top, left } = e.getBoundingClientRect();
  const viewportScrollTop = window.pageYOffset || document.body.scrollTop || 0;
  const viewportScrollLeft = window.pageXOffset || document.body.scrollLeft || 0;

  const offset = {
    top: top + viewportScrollTop,
    left: left + viewportScrollLeft,
  };

  return { e, width, height, offset };
};

export const overlap = (element, targets = []) => ({
  getOverlapData(p, t) {
    return {
      left: p.offset.left - t.offset.left,
      right: (t.offset.left + t.width) - (p.offset.left + p.width),
      top: p.offset.top - t.offset.top,
      bottom: (t.offset.top + t.height) - (p.offset.top + p.height),
    };
  },

  getIntersectionData(p, t, o) {
    const intersection = {
      width: p.width + (o.left < 0 ? o.left : 0) + (o.right < 0 ? o.right : 0),
      height: p.height + (o.top < 0 ? o.top : 0) + (o.bottom < 0 ? o.bottom : 0),
      offset: {
        left: null,
        top: null,
      },

      coverage: {
        player: 0,
        target: 0,
        total: 0,
      },
    };

    // Make sure width and height are not negative
    intersection.width = intersection.width < 0 ? 0 : intersection.width;
    intersection.height = intersection.height < 0 ? 0 : intersection.height;

    // If player overlaps target
    if (intersection.width > 0 && intersection.height > 0) {
      // Get intersection offset
      intersection.offset.left = p.offset.left + Math.abs(o.left < 0 ? o.left : 0);
      intersection.offset.top = p.offset.top + Math.abs(o.top < 0 ? o.top : 0);

      // Get intersection coverage
      intersection.coverage.player = (
        (intersection.width * intersection.height) / (p.width * p.height)
      ) * 100;

      intersection.coverage.target = (
        (intersection.width * intersection.height) / (t.width * t.height)
      ) * 100;

      intersection.coverage.total = intersection.coverage.player + intersection.coverage.target;
    }

    return intersection;
  },

  getInstanceData(pData, t) {
    const tData = getElementData(t);
    const overlapData = this.getOverlapData(pData, tData);
    const intersectionData = this.getIntersectionData(pData, tData, overlapData);

    tData.overlap = overlapData;
    tData.intersection = intersectionData;

    return tData;
  },

  overlap() {
    const cachedElement = getElementData(element);

    for (let target of targets) {
      const instanceData = this.getInstanceData(cachedElement, target);

      if (instanceData.intersection.coverage.total > 0) {
        return true;
      }
    }
  },
});

export const optimizedEvent = (event) => {
  const callbacks = [];
  let running = false;

  const runCallbacks = () => {
    callbacks.map(c => c());
    running = false;
  };

  const addCallback = c => callbacks.push(c);

  const action = () => {
    if (!running) {
      running = true;

      if (window.requestAnimationFrame) {
        window.requestAnimationFrame(runCallbacks);
      } else {
        setTimeout(runCallbacks, 66);
      }
    }
  };

  return {
    add(c) {
      if (!callbacks.length) {
        window.addEventListener(event, action);
      }

      return addCallback(c);
    },

    remove() {
      window.removeEventListener(event, action);
    },
  };
};

export const isFixed = (target, bottom, callback) => {
  const halfWindowHeight = window.innerHeight * 0.5;
  const scrollY = window.scrollY;
  const halfTargetHeight = target.height * 0.5;
  const topLocation = (scrollY + halfWindowHeight) - halfTargetHeight;
  const bottomLocation = (bottom.offset.top + halfTargetHeight) - (scrollY + halfWindowHeight);

  if ((topLocation >= target.offset.top && topLocation <= bottom.offset.top + 132)) {
    return callback(true);
  }

  return callback(false);
};



// WEBPACK FOOTER //
// ./src/components/Navigation/utils.js